enum ProductRateClassEnum {
  ConsumerDefault,
  ConsumerAll,
  Admin,
}

export default ProductRateClassEnum;
